"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    optionClassNames: function() {
        return optionClassNames;
    },
    useOptionStyles_unstable: function() {
        return useOptionStyles_unstable;
    }
});
const _react = require("@griffel/react");
const optionClassNames = {
    root: 'fui-Option',
    checkIcon: 'fui-Option__checkIcon'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bt984gj: "f122n59",
        Bbmb7ep: [
            "f1aa9q02",
            "f16jpd5f"
        ],
        Beyfa6y: [
            "f16jpd5f",
            "f1aa9q02"
        ],
        B7oj6ja: [
            "f1jar5jt",
            "fyu767a"
        ],
        Btl43ni: [
            "fyu767a",
            "f1jar5jt"
        ],
        sj55zd: "f19n0e5",
        i8kkvl: "f1ufnopg",
        Bceei9c: "f1k6fduh",
        mc9l5x: "f22iagw",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bg96gwp: "f1i3iumi",
        z8tnut: "fp2oml8",
        z189sj: [
            "f1vdfbxk",
            "f1f5gg8d"
        ],
        Byoj8tv: "f1tdddsa",
        uwmqm3: [
            "f1f5gg8d",
            "f1vdfbxk"
        ],
        qhf8xq: "f10pi13n",
        Jwef8y: "f1knas48",
        Bi91k9c: "feu1g3u",
        zqbkvg: "fo79ri9",
        h82x05: [
            "f1osiabc",
            "f1e8le25"
        ],
        cqj998: "f1yusjty",
        j3hlsh: [
            "f1e8le25",
            "f1osiabc"
        ],
        ecr2s2: "fb40n2d",
        lj723h: "f1g4hkjv",
        Btxx2vb: "f1lnr2zp",
        sltcwy: [
            "f1ogfk9z",
            "f1g7j8ec"
        ],
        dnwvvm: "fiuf46r",
        Blyvkvs: [
            "f1g7j8ec",
            "f1ogfk9z"
        ]
    },
    active: {
        Bsft5z2: "f13zj6fq",
        E3zdtr: "f1mdlcz9",
        B80jsxd: "f1nwj1ja",
        t2ki1e: "ffmd2fr",
        Bm2nyyq: "f8rth92",
        Barhvk9: [
            "flthirb",
            "ftkbnf5"
        ],
        Bw17bha: "f1lh990p",
        vfts7: [
            "ftkbnf5",
            "flthirb"
        ],
        xrcqlc: "fc9v8v1",
        Ihftqj: [
            "f1mwfetb",
            "f18mat8f"
        ],
        Bcgy8vk: "f1cb6c3",
        Bhxzhr1: [
            "f18mat8f",
            "f1mwfetb"
        ],
        B3778ie: [
            "f1ibwz09",
            "f1kp91vd"
        ],
        d9w3h3: [
            "f1kp91vd",
            "f1ibwz09"
        ],
        Bl18szs: [
            "f1pix4dl",
            "f13nd1z4"
        ],
        B4j8arr: [
            "f13nd1z4",
            "f1pix4dl"
        ],
        B0n5ga8: "f1qw5sz7",
        s924m2: [
            "f19va7ni",
            "f1a9v3mw"
        ],
        B1q35kw: "fkkziue",
        Gp14am: [
            "f1a9v3mw",
            "f19va7ni"
        ],
        bn5sak: "f1a97anr",
        By385i5: "f5226zp",
        Eqx8gd: [
            "fa2bdqt",
            "fei6g0k"
        ],
        B1piin3: [
            "fei6g0k",
            "fa2bdqt"
        ]
    },
    disabled: {
        sj55zd: "f1s2aq7o",
        Jwef8y: "f9ql6rf",
        Bi91k9c: "fvgxktp",
        zqbkvg: "f185j3qj",
        h82x05: [
            "f1dligi3",
            "f1vydzie"
        ],
        cqj998: "fjw1di3",
        j3hlsh: [
            "f1vydzie",
            "f1dligi3"
        ],
        ecr2s2: "fgj9um3",
        lj723h: "f19wldhg",
        Btxx2vb: "f1ss0kt2",
        sltcwy: [
            "f1t6oli3",
            "fjy9ci8"
        ],
        dnwvvm: "fresaxk",
        Blyvkvs: [
            "fjy9ci8",
            "f1t6oli3"
        ],
        Bbusuzp: "f1dcs8yz"
    },
    selected: {},
    checkIcon: {
        Be2twd7: "fod5ikn",
        Frg6f3: [
            "f18b9hdq",
            "fn6qj8t"
        ],
        t21cq0: [
            "f1xk557c",
            "f1h9en5y"
        ],
        Bcdw1i0: "fd7fpy0",
        Bo70h7d: "fvc9v3g"
    },
    selectedCheck: {
        Bcdw1i0: "f1022m68"
    },
    multiselectCheck: {
        B4j52fo: "f192inf7",
        Bekrc4i: [
            "f5tn483",
            "f1ojsxk5"
        ],
        Bn0qgzm: "f1vxd6vx",
        ibv6hh: [
            "f1ojsxk5",
            "f5tn483"
        ],
        icvyot: "fzkkow9",
        vrafjx: [
            "fcdblym",
            "fjik90z"
        ],
        oivjwe: "fg706s2",
        wvpqe5: [
            "fjik90z",
            "fcdblym"
        ],
        g2u3we: "fq0vr37",
        h3c5rm: [
            "f1byw159",
            "f11cr0be"
        ],
        B9xav0g: "f1c1zstj",
        zhjwy3: [
            "f11cr0be",
            "f1byw159"
        ],
        Bbmb7ep: [
            "f1g3puop",
            "fi2rrw2"
        ],
        Beyfa6y: [
            "fi2rrw2",
            "f1g3puop"
        ],
        B7oj6ja: [
            "f1rstyi9",
            "f1s4nn1u"
        ],
        Btl43ni: [
            "f1s4nn1u",
            "f1rstyi9"
        ],
        B7ck84d: "f1ewtqcl",
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59",
        Brf1p80: "f4d9j23",
        Bkfmm31: "f1w9h62z",
        Be2twd7: "f1ugzwwg",
        Bqenvij: "fd461yt",
        a9b677: "fjw5fx7",
        Bcdw1i0: "f1022m68"
    },
    selectedMultiselectCheck: {
        De3pzq: "ftywsgz",
        sj55zd: "fqpbvvt",
        g2u3we: "f3xi7mh",
        h3c5rm: [
            "ftovhe4",
            "f1wczvin"
        ],
        B9xav0g: "f68vbr6",
        zhjwy3: [
            "f1wczvin",
            "ftovhe4"
        ]
    },
    checkDisabled: {
        sj55zd: "f1s2aq7o",
        Bbusuzp: "f1dcs8yz"
    },
    multiselectCheckDisabled: {
        g2u3we: "f1r1t4y1",
        h3c5rm: [
            "fmj8ijw",
            "figx54m"
        ],
        B9xav0g: "f360ss8",
        zhjwy3: [
            "figx54m",
            "fmj8ijw"
        ]
    }
}, {
    d: [
        ".f122n59{align-items:center;}",
        ".f1aa9q02{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f16jpd5f{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f1jar5jt{border-top-right-radius:var(--borderRadiusMedium);}",
        ".fyu767a{border-top-left-radius:var(--borderRadiusMedium);}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".f1ufnopg{column-gap:var(--spacingHorizontalXS);}",
        ".f1k6fduh{cursor:pointer;}",
        ".f22iagw{display:flex;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".fp2oml8{padding-top:var(--spacingVerticalSNudge);}",
        ".f1vdfbxk{padding-right:var(--spacingHorizontalS);}",
        ".f1f5gg8d{padding-left:var(--spacingHorizontalS);}",
        ".f1tdddsa{padding-bottom:var(--spacingVerticalSNudge);}",
        ".f10pi13n{position:relative;}",
        ".f13zj6fq::after{content:\"\";}",
        ".f1mdlcz9::after{position:absolute;}",
        ".f1nwj1ja::after{pointer-events:none;}",
        ".ffmd2fr::after{z-index:1;}",
        ".f8rth92::after{border-top-style:solid;}",
        ".flthirb::after{border-right-style:solid;}",
        ".ftkbnf5::after{border-left-style:solid;}",
        ".f1lh990p::after{border-bottom-style:solid;}",
        ".fc9v8v1::after{border-top-width:2px;}",
        ".f1mwfetb::after{border-right-width:2px;}",
        ".f18mat8f::after{border-left-width:2px;}",
        ".f1cb6c3::after{border-bottom-width:2px;}",
        ".f1ibwz09::after{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f1kp91vd::after{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f1pix4dl::after{border-top-right-radius:var(--borderRadiusMedium);}",
        ".f13nd1z4::after{border-top-left-radius:var(--borderRadiusMedium);}",
        ".f1qw5sz7::after{border-top-color:var(--colorStrokeFocus2);}",
        ".f19va7ni::after{border-right-color:var(--colorStrokeFocus2);}",
        ".f1a9v3mw::after{border-left-color:var(--colorStrokeFocus2);}",
        ".fkkziue::after{border-bottom-color:var(--colorStrokeFocus2);}",
        ".f1a97anr::after{top:-2px;}",
        ".f5226zp::after{bottom:-2px;}",
        ".fa2bdqt::after{left:-2px;}",
        ".fei6g0k::after{right:-2px;}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".f18b9hdq{margin-left:calc(var(--spacingHorizontalXXS) * -1);}",
        ".fn6qj8t{margin-right:calc(var(--spacingHorizontalXXS) * -1);}",
        ".f1xk557c{margin-right:var(--spacingHorizontalXXS);}",
        ".f1h9en5y{margin-left:var(--spacingHorizontalXXS);}",
        ".fd7fpy0{visibility:hidden;}",
        ".fvc9v3g svg{display:block;}",
        ".f1022m68{visibility:visible;}",
        ".f192inf7{border-top-width:var(--strokeWidthThin);}",
        ".f5tn483{border-right-width:var(--strokeWidthThin);}",
        ".f1ojsxk5{border-left-width:var(--strokeWidthThin);}",
        ".f1vxd6vx{border-bottom-width:var(--strokeWidthThin);}",
        ".fzkkow9{border-top-style:solid;}",
        ".fcdblym{border-right-style:solid;}",
        ".fjik90z{border-left-style:solid;}",
        ".fg706s2{border-bottom-style:solid;}",
        ".fq0vr37{border-top-color:var(--colorNeutralStrokeAccessible);}",
        ".f1byw159{border-right-color:var(--colorNeutralStrokeAccessible);}",
        ".f11cr0be{border-left-color:var(--colorNeutralStrokeAccessible);}",
        ".f1c1zstj{border-bottom-color:var(--colorNeutralStrokeAccessible);}",
        ".f1g3puop{border-bottom-right-radius:var(--borderRadiusSmall);}",
        ".fi2rrw2{border-bottom-left-radius:var(--borderRadiusSmall);}",
        ".f1rstyi9{border-top-right-radius:var(--borderRadiusSmall);}",
        ".f1s4nn1u{border-top-left-radius:var(--borderRadiusSmall);}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f4d9j23{justify-content:center;}",
        ".f1w9h62z{fill:currentColor;}",
        ".f1ugzwwg{font-size:12px;}",
        ".fd461yt{height:16px;}",
        ".fjw5fx7{width:16px;}",
        ".ftywsgz{background-color:var(--colorCompoundBrandBackground);}",
        ".fqpbvvt{color:var(--colorNeutralForegroundInverted);}",
        ".f3xi7mh{border-top-color:var(--colorCompoundBrandBackground);}",
        ".ftovhe4{border-right-color:var(--colorCompoundBrandBackground);}",
        ".f1wczvin{border-left-color:var(--colorCompoundBrandBackground);}",
        ".f68vbr6{border-bottom-color:var(--colorCompoundBrandBackground);}",
        ".f1r1t4y1{border-top-color:var(--colorNeutralForegroundDisabled);}",
        ".fmj8ijw{border-right-color:var(--colorNeutralForegroundDisabled);}",
        ".figx54m{border-left-color:var(--colorNeutralForegroundDisabled);}",
        ".f360ss8{border-bottom-color:var(--colorNeutralForegroundDisabled);}"
    ],
    h: [
        ".f1knas48:hover{background-color:var(--colorNeutralBackground1Hover);}",
        ".feu1g3u:hover{color:var(--colorNeutralForeground1Hover);}",
        ".fo79ri9:hover .fui-Option__checkIcon{border-top-color:var(--colorNeutralForeground1Hover);}",
        ".f1osiabc:hover .fui-Option__checkIcon{border-right-color:var(--colorNeutralForeground1Hover);}",
        ".f1e8le25:hover .fui-Option__checkIcon{border-left-color:var(--colorNeutralForeground1Hover);}",
        ".f1yusjty:hover .fui-Option__checkIcon{border-bottom-color:var(--colorNeutralForeground1Hover);}",
        ".f9ql6rf:hover{background-color:var(--colorTransparentBackground);}",
        ".fvgxktp:hover{color:var(--colorNeutralForegroundDisabled);}",
        ".f185j3qj:hover .fui-Option__checkIcon{border-top-color:var(--colorNeutralForegroundDisabled);}",
        ".f1dligi3:hover .fui-Option__checkIcon{border-right-color:var(--colorNeutralForegroundDisabled);}",
        ".f1vydzie:hover .fui-Option__checkIcon{border-left-color:var(--colorNeutralForegroundDisabled);}",
        ".fjw1di3:hover .fui-Option__checkIcon{border-bottom-color:var(--colorNeutralForegroundDisabled);}"
    ],
    a: [
        ".fb40n2d:active{background-color:var(--colorNeutralBackground1Pressed);}",
        ".f1g4hkjv:active{color:var(--colorNeutralForeground1Pressed);}",
        ".f1lnr2zp:active .fui-Option__checkIcon{border-top-color:var(--colorNeutralForeground1Hover);}",
        ".f1ogfk9z:active .fui-Option__checkIcon{border-right-color:var(--colorNeutralForeground1Hover);}",
        ".f1g7j8ec:active .fui-Option__checkIcon{border-left-color:var(--colorNeutralForeground1Hover);}",
        ".fiuf46r:active .fui-Option__checkIcon{border-bottom-color:var(--colorNeutralForeground1Hover);}",
        ".fgj9um3:active{background-color:var(--colorTransparentBackground);}",
        ".f19wldhg:active{color:var(--colorNeutralForegroundDisabled);}",
        ".f1ss0kt2:active .fui-Option__checkIcon{border-top-color:var(--colorNeutralForegroundDisabled);}",
        ".f1t6oli3:active .fui-Option__checkIcon{border-right-color:var(--colorNeutralForegroundDisabled);}",
        ".fjy9ci8:active .fui-Option__checkIcon{border-left-color:var(--colorNeutralForegroundDisabled);}",
        ".fresaxk:active .fui-Option__checkIcon{border-bottom-color:var(--colorNeutralForegroundDisabled);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1dcs8yz{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const useOptionStyles_unstable = (state)=>{
    const { active, disabled, focusVisible, multiselect, selected } = state;
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(optionClassNames.root, styles.root, active && focusVisible && styles.active, disabled && styles.disabled, selected && styles.selected, state.root.className);
    if (state.checkIcon) {
        state.checkIcon.className = (0, _react.mergeClasses)(optionClassNames.checkIcon, styles.checkIcon, multiselect && styles.multiselectCheck, selected && styles.selectedCheck, selected && multiselect && styles.selectedMultiselectCheck, disabled && styles.checkDisabled, disabled && multiselect && styles.multiselectCheckDisabled, state.checkIcon.className);
    }
    return state;
}; //# sourceMappingURL=useOptionStyles.styles.js.map
